// extracted by mini-css-extract-plugin
export default {"buttonLinkedin":"Linkedin_buttonLinkedin__JCaaU","imgLinkedin":"Linkedin_imgLinkedin__ktXJC"};